<div
	*ngIf="projectCarrierMapList?.length > 0"
	class="allocated_carriers_list_container"
>
	<cdk-virtual-scroll-viewport
		itemSize="125"
		[minBufferPx]="20"
		[maxBufferPx]="40"
		style="flex: 1; overflow: auto"
	>
		<mat-accordion fxFlex="100">
			<mat-expansion-panel
				#panel
				*cdkVirtualFor="
					let projectCarrierMap of projectCarrierMapList;
					let cIndex = index;
					trackBy: trackByFn
				"
				[expanded]="step == cIndex"
				[class.is-expanded]="step === cIndex"
				[hideToggle]="true"
				[ngClass]="{
					'mat-elevation-z4 primary-border': selectedMatch?.id == projectCarrierMap.id,
					'panel-selected mat-elevation-z4':
						selectedProjectCarrierMapIDs.indexOf(projectCarrierMap.id) > -1,
				}"
				[ngStyle]="{ 'margin-top': cIndex && cIndex > 0 ? '1rem' : 0 }"
				class="custom-panel mat-elevation-z1"
				[attr.id]="'allocatedCarriers-' + projectCarrierMap.id"
			>
				<mat-expansion-panel-header
					(mousedown)="$event.stopImmediatePropagation()"
					(click)="
						$event.stopImmediatePropagation();
						emitPanelClickedEvent(projectCarrierMap, $event, cIndex, false)
					"
					(keydown.arrowdown)="$event.stopImmediatePropagation()"
					(keydown.arrowup)="$event.stopImmediatePropagation()"
					(keydown.enter)="$event.stopImmediatePropagation()"
					id="{{ projectCarrierMap.carrier.id }}"
				>
					<table class="full-width" fxFlex="100">
						<tr fxLayout="row">
							<td #businessNameContainer fxFlex fxLayout="row" fxLayoutAlign="start center">
								<div
									[ngStyle]="{
										'max-width':
											'calc(' +
											(businessNameContainer?.offsetWidth
												? businessNameContainer.offsetWidth -
													(20 +
														(projectCarrierMap.carrierLastOpenedEmailAt ? 100 : 8) +
														(IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.active) &&
														!projectCarrierMap.carrier.active
															? 160
															: 8))
												: 230) +
											'px)',
									}"
									class="ellipsis"
								>
									<b *ngIf="projectCarrierMap.carrier.customerCarrier" class="font-size-16">
										{{
											GET_CARRIER_BUSINESS_NAME(
												projectCarrierMap.carrier.businessName,
												projectCarrierMap.carrier.doingBusinessAs
											)
										}}
									</b>
									<span *ngIf="!projectCarrierMap.carrier.customerCarrier" class="font-size-16">
										{{
											GET_CARRIER_BUSINESS_NAME(
												projectCarrierMap.carrier.businessName,
												projectCarrierMap.carrier.doingBusinessAs
											)
										}}
									</span>
								</div>

								<div
									*ngIf="
										SHOW_IN_NETWORK_LOGO(
											CARRIER_QUALITY_ENABLED,
											projectCarrierMap.carrier.dot,
											isCarrierVettingIntegrationEnabled,
											getVettingSource(projectCarrierMap.carrier.accountCarrierMaps),
											getVettingSourceId(projectCarrierMap.carrier.accountCarrierMaps),
											carrierVettingService,
											projectCarrierMap.carrier.id,
											projectCarrierMap.carrier.customerCarrier
										)
									"
									fxLayoutAlign="start center"
								>
									<img
										[src]="
											carrierVettingService.logo(
												getVettingSource(projectCarrierMap.carrier.accountCarrierMaps)
											)
										"
										[matTooltip]="
											carrierVettingService.tooltip(
												getVettingSource(projectCarrierMap.carrier.accountCarrierMaps),
												getAccountCarrierMap(
													projectCarrierMap.carrier.accountCarrierMaps,
													projectCarrierMap.carrier
												)?.carrierOnboardedOn,
												getAccountCarrierMap(
													projectCarrierMap.carrier.accountCarrierMaps,
													projectCarrierMap.carrier
												)?.lastVettingTime
											)
										"
										class="h-18 in_network_logo"
									/>
								</div>

								<img
									*ngIf="projectCarrierMap.carrier?.haulPayApproved && environment.SHOW_QUALITY"
									class="h-18 in_network_logo"
									[src]="haulpayService.logo()"
									[matTooltip]="haulpayService.tooltip()"
								/>

								<span
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrierLastOpenedEmailAt)"
									class="font-size-16"
								>
									(RFP Viewed)
								</span>

								<div
									*ngIf="
										IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.carrier.active) &&
										!projectCarrierMap.carrier.active
									"
									class="font-size-12"
								>
									Carrier not authorized.
								</div>
							</td>

							<!-- Allocation info prominently displayed -->
							<td fxFlex="25" fxLayoutAlign="start center">
								<div
									class="full-width p-r-1 p-l-1 allocation-info-section"
									(click)="emitEditAllocationEvent(projectCarrierMap, $event)"
									fxLayoutAlign="space-between center"
								>
									<span
										class="allocation-badge-large"
										[matTooltip]="'Click to edit allocation'"
									>
										<mat-icon class="font-size-16 allocation-icon-large">pie_chart</mat-icon>
										<span class="allocation-text-large">{{ getAllocationSummary(projectCarrierMap.carrier.id) }}</span>
									</span>
									<span *ngIf="getAllocationWindow(projectCarrierMap.carrier.id)" class="allocation-window font-size-12">
										{{ getAllocationWindow(projectCarrierMap.carrier.id) }}
									</span>
								</div>
							</td>

							<td fxFlex="20" fxLayoutAlign="start start">
								<div
									class="full-width p-r-1 p-l-1"
									(click)="$event.stopPropagation()"
									fxLayoutAlign="space-between center"
									*ngIf="accountSettings.CARRIER_QUALITY"
								>
									<span class="font-size-14 font-weight-bold">Quality Score: </span>
									<span
										class="font-size-14 font-weight-bold {{
											getCcScoreDisplay(
												projectCarrierMap.carrier.accountCarrierMaps,
												projectCarrierMap.carrier
											) || 'N/A'
										}}"
									>
										{{
											getCcScoreDisplay(
												projectCarrierMap.carrier.accountCarrierMaps,
												projectCarrierMap.carrier
											) || 'N/A'
										}}
									</span>
								</div>
							</td>

							<td fxFlex="16" fxLayoutAlign="start center">
								<div
									class="full-width"
									(click)="$event.stopPropagation()"
									fxLayoutAlign="space-between center"
									*ngIf="projectCarrierMap.matchScore; else na"
								>
									<span class="font-size-14"> Match Confidence </span>
									<span class="font-size-14 font-weight-bold success-text">
										<meter
											high="66"
											low="33"
											max="100"
											min="0"
											optimum="90"
											value="{{ projectCarrierMap.matchScore }}"
											[matTooltip]="projectCarrierMap.matchScore"
											matTooltipClass="custom-tooltip"
										></meter>
									</span>
								</div>
							</td>

							<td fxFlex="11" fxLayoutAlign="end start">
								<div
									class="full-width"
									*ngIf="
										productsService.ASSIGN_CARRIERS &&
										IS_NOT_NULL_OR_UNDEFINED(usersList) &&
										usersList.length > 0 &&
										IS_NOT_NULL_OR_UNDEFINED(userCarrierMapList)
									"
								>
									<app-user-selector
										(userChanged)="setAssignee($event, projectCarrierMap.carrier.id)"
										[selectedUsers]="
											IS_NULL_OR_UNDEFINED(userCarrierMap[projectCarrierMap.carrier.id])
												? []
												: [getUserIdAssigned(projectCarrierMap.carrier.id)]
										"
										[showAssignMe]="false"
										[singleselect]="true"
										[usersList]="usersList"
										[allUsersList]="allUsersList"
										customCssClass="custom-form-field assignn_rep_max_width"
										floatLabel="never"
										fxFlex
										placeholder="Assign Rep"
									></app-user-selector>
								</div>
								<span
									(click)="emitPanelClickedEvent(projectCarrierMap, $event, cIndex, true)"
									class="project-details-selection"
									matTooltip
								>
									<mat-icon>check_circle</mat-icon>
								</span>
							</td>
						</tr>

						<tr class="font-size-14 mt-3" fxLayout="row">
							<td fxFlex>
								<div (click)="$event.stopPropagation()" fxLayoutAlign="start center">
									<span
										#mcDotContainer
										*ngIf="
											IS_NOT_EMPTY(projectCarrierMap.carrier.dot) ||
											IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
										"
										class="font-size-14"
									>
										<span
											(click)="
												utilService.copyToClipboard(
													projectCarrierMap.carrier.mc,
													COPY_TO_CLIPBOARD_MSGS.MC
												)
											"
											*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.mc)"
										>
											MC: {{ projectCarrierMap.carrier.mc }}
										</span>
										{{
											IS_NOT_EMPTY(projectCarrierMap.carrier.dot) &&
											IS_NOT_EMPTY(projectCarrierMap.carrier.mc)
												? ' / '
												: ''
										}}
										<span
											(click)="
												utilService.copyToClipboard(
													projectCarrierMap.carrier.dot,
													COPY_TO_CLIPBOARD_MSGS.DOT
												)
											"
											*ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.dot)"
										>
											DOT: {{ projectCarrierMap.carrier.dot }}
										</span>
									</span>
								</div>
							</td>
							<td fxFlex="25" fxLayoutAlign="start center">
								<!-- Empty - allocation info is in header -->
							</td>
							<td fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Authority:</span>
									<span>
										{{
											projectCarrierMap.carrier.authorityGrantDate
												? DATE_MDY(projectCarrierMap.carrier.authorityGrantDate)
												: 'N/A'
										}}
									</span>
								</div>
							</td>
							<td fxFlex="16" fxLayoutAlign="start center">
								<div class="full-width" fxLayoutAlign="space-between center">
									<span>Lane:&nbsp;</span>
									<span
										*ngIf="projectCarrierMap.lanePath; else na"
										[appTruncateTooltip]="projectCarrierMap.lanePath || ''"
										class="font-size-12 truncate_text"
									>
										{{ projectCarrierMap.lanePath }}
									</span>
								</div>
							</td>

							<td fxFlex="11" fxLayoutAlign="end end">
								<div
									class="full-width"
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.laneCount)"
									(click)="
										$event.stopPropagation();
										emitOpenFullProfileEventEvent(projectCarrierMap, $event)
									"
									fxLayoutAlign="space-between center"
								>
									<span>
										{{
											projectCarrierMap.laneCount +
												' Lane' +
												(projectCarrierMap.laneCount > 1 ? 's' : '')
										}}
									</span>
									<span>
										<img class="ml-4" height="18px" src="./assets/icons/road.svg" />
									</span>
								</div>
							</td>
						</tr>

						<tr class="font-size-14 mt-3" fxLayout="row">
							<td fxFlex>
								<div class="full-width" fxLayoutAlign="start center">
									<span>PU: {{ projectCarrierMap.carrier.powerUnits }}</span>
									<span>&nbsp; / &nbsp;</span>
									<span>T: {{ projectCarrierMap.carrier.trailers }}</span>
									<span>&nbsp; / &nbsp;</span>
									<span>D: {{ projectCarrierMap.carrier.drivers }}</span>
									<span>&nbsp;/ C: {{ projectCarrierMap.carrier.contacts.length || 'N/A' }} </span>
								</div>
							</td>
							<td fxFlex="25" fxLayoutAlign="start center">
								<!-- Empty -->
							</td>
							<td fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Insurance: </span>
									<span *ngIf="projectCarrierMap.carrier.cargoInsuranceAmount">
										{{
											projectCarrierMap.carrier.cargoInsuranceAmount
												| currency: 'USD' : 'symbol' : '1.0-0'
										}}
									</span>
									<span *ngIf="!projectCarrierMap.carrier.cargoInsuranceAmount">N/A</span>
								</div>
							</td>
							<td fxFlex="16" fxLayoutAlign="start center">
								<div class="full-width" fxLayoutAlign="space-between center">
									<span> Frequency: </span>
									<span
										*ngIf="projectCarrierMap.frequency; else na"
										[appTruncateTooltip]="projectCarrierMap.lanePath || ''"
										class="font-size-12 truncate_text"
									>
										{{ projectCarrierMap.frequency }}
										{{
											!utilService.isNullOrUndefined(projectCarrierMap.frequency) &&
											isFrequencyValidNumber(projectCarrierMap.frequency)
												? '/ weekly'
												: ''
										}}
									</span>
								</div>
							</td>
							<td fxFlex="11" fxLayoutAlign="end center">
								<div
									*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.notesCount)"
									class="full-width"
									(click)="$event.stopPropagation()"
								>
									<div
										*ngIf="projectCarrierMap.notesCount > 0"
										fxLayoutAlign="space-between center"
										class="full-width"
									>
										<span>
											{{
												projectCarrierMap.notesCount +
													' Note' +
													(projectCarrierMap.notesCount > 1 ? 's' : '')
											}}
										</span>
										<span fxLayoutAlign="start center">
											<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
										</span>
									</div>
									<div
										*ngIf="projectCarrierMap.notesCount == 0"
										fxLayoutAlign="space-between center"
										class="full-width"
									>
										<span class="primary-text">No Notes</span>
										<span fxLayoutAlign="start center">
											<img class="ml-4 px-2" height="18px" src="./assets/icons/sticky-note.svg" />
										</span>
									</div>
								</div>
							</td>
						</tr>

						<tr class="font-size-14 mt-3" fxLayout="row">
							<td fxFlex>
								<div
									class="full-width"
									fxLayoutAlign="start center"
									*ngIf="
										IS_NOT_EMPTY(projectCarrierMap.carrier.city) ||
										IS_NOT_EMPTY(projectCarrierMap.carrier.state)
									"
								>
									HQ:&nbsp;
									<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.city)">
										{{ projectCarrierMap.carrier.city
										}}{{ IS_NOT_EMPTY(projectCarrierMap.carrier.state) ? ',' : '' }}
									</span>
									<span *ngIf="IS_NOT_EMPTY(projectCarrierMap.carrier.state)">
										{{ projectCarrierMap.carrier.state }}
									</span>
								</div>
							</td>
							<td fxFlex="25" fxLayoutAlign="start center">
								<!-- Empty -->
							</td>
							<td fxFlex="20" fxLayoutAlign="start center">
								<div class="full-width p-r-1 p-l-1" fxLayoutAlign="space-between center">
									<span>Violations: </span>
									<span>N/A</span>
								</div>
							</td>
							<td fxFlex="16" fxLayoutAlign="start center">
								<div class="full-width" fxLayoutAlign="space-between center">
									<span>
										<span>DH-O:</span>
										<span
											*ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.originDeadhead); else na"
										>
											{{ projectCarrierMap.originDeadhead | number: '1.0-0' }}
										</span>
									</span>
									<span>
										<span class="m-l-1">DH-D:</span>
										<span
											*ngIf="
												IS_NOT_NULL_OR_UNDEFINED(projectCarrierMap.destinationDeadhead);
												else na
											"
										>
											{{ projectCarrierMap.destinationDeadhead | number: '1.0-0' }}
										</span>
									</span>
								</div>
							</td>
							<td fxFlex="11" fxLayoutAlign="start center">
								<div class="full-width" *ngIf="projectCarrierMap.projectsList">
									<div
										fxLayoutAlign="space-between center"
										class="full-width dropdown"
										*ngIf="projectCarrierMap.projectsList?.length > 0"
									>
										<span>
											{{ projectCarrierMap.projectsList.length }}
											{{ projectCarrierMap.projectsList.length > 1 ? 'Projects' : 'Project' }}
										</span>
										<span fxLayoutAlign="start center">
											<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
										</span>
									</div>

									<div
										fxLayoutAlign="space-between center"
										class="full-width"
										*ngIf="projectCarrierMap.projectsList.length == 0"
									>
										<span class="primary-text">No Projects</span>
										<span fxLayoutAlign="start center">
											<mat-icon class="font-size-18 h-18 ml-4 pl-2 w-inherit">assignment</mat-icon>
										</span>
									</div>
								</div>
							</td>
						</tr>
						<tr class="font-size-14 mt-3" fxLayout="row" *ngIf="step === cIndex">
							<td fxFlex fxLayoutAlign="start center">
								<div
									fxLayoutAlign="end center"
									(click)="
										utilService.copyToClipboard(
											projectCarrierMap.carrier.businessEmailAddress,
											COPY_TO_CLIPBOARD_MSGS.EMAIL
										)
									"
									*ngIf="projectCarrierMap.carrier.businessEmailAddress"
								>
									<span class="text-nowrap">Main Email:</span>
									<span class="font-size-14 truncate_text">
										<a href="mailto:{{ projectCarrierMap.carrier.businessEmailAddress }}">{{
											projectCarrierMap.carrier.businessEmailAddress?.toLowerCase()
										}}</a>
									</span>
								</div>
							</td>
							<td fxFlex="25" fxLayoutAlign="start center">
								<!-- Empty -->
							</td>
							<td fxFlex="20" fxLayoutAlign="start center">
								<div
									fxLayoutAlign="space-between center"
									class="full-width p-r-1 p-l-1"
									*ngIf="projectCarrierMap.carrier.representative1"
								>
									<span class="text-nowrap">Contact:</span>
									<span class="font-size-12 truncate_text capitalize">{{
										projectCarrierMap.carrier.representative1?.toLowerCase()
									}}</span>
								</div>
							</td>
							<td fxFlex="16">
								<div
									fxLayoutAlign="space-between center"
									class="full-width"
									*ngIf="projectCarrierMap.carrier.phone"
								>
									<span>Phone:</span>
									<span
										><a href="tel:{{ projectCarrierMap.carrier.phone }}">{{
											projectCarrierMap.carrier.phone
										}}</a></span
									>
								</div>
							</td>
							<td fxFlex="11"></td>
						</tr>
					</table>
				</mat-expansion-panel-header>

				<ng-template [ngIf]="step == cIndex">
					<div fxLayout="row">
						<div fxFlex fxLayoutAlign="end end" fxLayoutGap="16px">
							<a
								(click)="emitEditAllocationEvent(projectCarrierMap, $event)"
								class="cursor-pointer"
							>
								<span class="primary-text m-r-1 p-r-0-5"><u>Edit Allocation</u></span>
							</a>
							<a
								(click)="emitOpenFullProfileEventEvent(projectCarrierMap, $event)"
								class="cursor-pointer"
							>
								<span class="primary-text m-r-1 p-r-0-5"><u>Full Profile</u></span>
							</a>
						</div>
					</div>
					<div
						*ngIf="
							accountSettings.IS_FEEDBACK_ENABLED &&
							USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN &&
							accountId &&
							step == cIndex
						"
						class="p-l-1 p-r-1"
					>
						<app-carrier-feedbacks
							[accountId]="accountId"
							[carrierId]="projectCarrierMap.carrier.id"
						>
						</app-carrier-feedbacks>
					</div>
					<div class="p-l-1 p-r-1" fxLayout="row">
						<h3 class="primary-text" fxFlex>Representatives</h3>
					</div>
					<div class="p-l-1 p-r-1 p-b-1" *ngIf="isContactsListInitialised">
						<app-carrier-contacts
							(updateContactsList)="updateContactsList($event)"
							(onProjectCarrierMapContact)="onProjectCarrierMapContact($event)"
							[carrierId]="projectCarrierMap.carrier.id"
							[carrier]="projectCarrierMap?.carrier"
							[contactList]="contactList"
							[editPrimaryContact]="false"
							[isCarrierProfile]="true"
							[isEditContact]="true"
							[oldCarrierId]="null"
							[showContactSearchIcon]="true"
							[mapContactToProjectColumnEnabled]="true"
							[projectCarrierMap]="selectedProjectCarrierMap | async"
							[rowSelectionEnabled]="true"
							[showAddContactIcon]="false"
						>
						</app-carrier-contacts>
					</div>
				</ng-template>
			</mat-expansion-panel>
		</mat-accordion>
	</cdk-virtual-scroll-viewport>
</div>

<ng-template #na>
	<span> N/A </span>
</ng-template>
